import React, { useState } from 'react'
import { FaTrash, FaCheck, FaPlus } from 'react-icons/fa'
import GuidedTour from '../onboarding/shared/GuidedTour'
import GuidedTourMobile from '../onboarding/shared/GuidedTourMobile'
import { Theme } from '../../lib/theme';
type DesktopActionButtonsProps = {
  onDelete: () => void
  onFinalize: () => void
  onNewVersion: () => void
  finalized: boolean
  currentSlideId?: string
  userPlan: string
  deleteFinalizeDisabled: boolean
  newVersionDisabled: boolean
  isQuickGenerating: boolean
  showEligibilityTooltip:boolean
}

export const DesktopButtonSection: React.FC<DesktopActionButtonsProps> = ({
  onDelete,
  onFinalize,
  onNewVersion,
  finalized,
  currentSlideId,
  userPlan,
  deleteFinalizeDisabled,
  newVersionDisabled,
  isQuickGenerating,
  showEligibilityTooltip
}) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false)
  const [isDialogVisibledelete, setIsDialogVisibledelete] = useState(false)
  const [isDialogVisibleNew, setIsDialogVisibleNew] = useState(false)
  const [ishovered,setishovered]=useState(false);
  const [pricingModal,setIsPricingModalOpen]=useState(false)


  return (
<div className="relative flex gap-2">
  {/* Delete Button */}
  <button
    id="delete"
    onClick={onDelete}
    disabled={deleteFinalizeDisabled}
    className="border p-2 rounded-md flex items-center active:scale-95 transition transform duration-300 disabled:cursor-not-allowed hover:text-red-600"
    style={{
      borderColor: Theme.colors.stroke.weak,
      color: Theme.colors.text.weak,
    }}
    onMouseEnter={() => setIsDialogVisibledelete(true)}
    onMouseLeave={() => setIsDialogVisibledelete(false)}
  >
    <FaTrash className="h-4 w-4 mr-1" style={{ color: Theme.colors.text.weak }} />
    <span className="hidden lg:block">Delete Version</span>
  </button>

  {/* Finalize Button */}
  <button
    id="finalize"
    onClick={onFinalize}
    disabled={deleteFinalizeDisabled}
    className="p-2 rounded-md flex items-center border active:scale-95 transition transform duration-300 disabled:cursor-not-allowed"
    style={{
      borderColor: currentSlideId && finalized
        ? Theme.colors.button.primary
        : Theme.colors.stroke.weak,
      backgroundColor: currentSlideId && finalized ? "#36fa810a" : "transparent",
    }}
    onMouseEnter={() => setIsDialogVisible(true)}
    onMouseLeave={() => setIsDialogVisible(false)}
  >
    <FaCheck
      className="h-4 w-4 mr-1"
      style={{
        color: finalized ? Theme.colors.button.primary : Theme.colors.text.weak,
      }}
    />
    <span className="hidden lg:block" style={{ color: Theme.colors.text.weak }}>
      Finalize Version
    </span>
  </button>

  {/* New Version Button */}
  <button
    onClick={onNewVersion}
    id="new-version"
    disabled={newVersionDisabled}
    className="border p-2 rounded-md flex items-center active:scale-95 transition transform duration-300 disabled:cursor-not-allowed hover:text-blue-600"
    style={{
      borderColor: Theme.colors.primary,
      color: Theme.colors.primary,
    }}
    onMouseEnter={() => setIsDialogVisibleNew(true)}
    onMouseLeave={() => setIsDialogVisibleNew(false)}
  >
    <FaPlus className="h-4 w-4 mr-1" style={{ color: Theme.colors.primary }} />
    <span className="hidden lg:block">New Version</span>
  </button>
</div>
  )
}

type MobileActionButtonsProps = {
  onDelete: () => void
  onFinalize: () => void
  onNewVersion: () => void
  finalized: boolean
  currentSlideId?: string
  displayMode: string
  deleteFinalizeDisabled: boolean
  newVersionDisabled: boolean
  isQuickGenerating: boolean
}

export const MobileButtonSection: React.FC<MobileActionButtonsProps> = ({
  onDelete,
  onFinalize,
  onNewVersion,
  finalized,
  currentSlideId,
  displayMode,
  deleteFinalizeDisabled,
  newVersionDisabled,
  isQuickGenerating,
}) => {


  return (
<div className="flex gap-4">
  {/* Delete Button */}
  <button
    id="delete-mobile"
    disabled={deleteFinalizeDisabled}
    onClick={onDelete}
    className="border p-2 rounded-md flex items-center disabled:cursor-not-allowed hover:text-red-600"
    style={{
      borderColor: Theme.colors.stroke.weak,
      color: Theme.colors.text.weak,
    }}
  >
    <FaTrash className="h-4 w-4" style={{ color: Theme.colors.text.weak }} />
  </button>

  {/* Finalize Button */}
  <button
    id="finalize-mobile"
    onClick={onFinalize}
    disabled={deleteFinalizeDisabled}
    className="border p-2 rounded-md flex items-center disabled:cursor-not-allowed"
    style={{
      borderColor:
        currentSlideId && finalized
          ? Theme.colors.button.primary
          : Theme.colors.stroke.weak,
      backgroundColor: currentSlideId && finalized ? "#36fa810a" : "transparent",
    }}
  >
    <FaCheck
      className="h-4 w-4"
      style={{
        color: currentSlideId && finalized
          ? Theme.colors.button.primary
          : Theme.colors.text.weak,
      }}
    />
  </button>

  {/* New Version Button */}
  <button
    id="new-version-mobile"
    onClick={onNewVersion}
    disabled={newVersionDisabled}
    className="border p-2 rounded-md flex items-center disabled:cursor-not-allowed hover:text-blue-600"
    style={{
      borderColor:
        displayMode === "newContent"
          ? Theme.colors.stroke.weak
          : Theme.colors.primary,
      color:
        displayMode === "newContent"
          ? Theme.colors.text.weak
          : Theme.colors.primary,
    }}
  >
    <FaPlus
      className="h-4 w-4"
      style={{
        color:
          displayMode === "newContent"
            ? Theme.colors.text.weak
            : Theme.colors.primary,
      }}
    />
  </button>

  <GuidedTour />
  <GuidedTourMobile />
</div>
  )
}
